import * as React from 'react';
import Helmet from 'react-helmet';

export const NoIndexMeta: React.FC<{ noIndex: boolean }> = props => {
  const { noIndex } = props;
  return noIndex ? <Helmet><meta name="robots" content="noindex" /></Helmet> : null;
};
